import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import DataFilter from '../views/DataFilter.vue'
import PageNotFound from '../views/PageNotFound.vue'
import Guard from '../services/middleware'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: Guard.auth,
    children:[
      {
        path: ':data',
        name: 'DataFilter',
        component: DataFilter,
        beforeEnter: (to, from, next) => { 
          if(!isNaN(Date.parse(to.params.data))){
            next();
          }else{
            next('/');
          }
        },
        meta: { title:  '-'} 
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'Portal do Administrador | Login' } 
  },
  { 
    path: "/:pathMatch(.*)", 
    name: 'PageNotFound',
    component: PageNotFound 
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
